module.exports = __webpack_public_path__ + "static/media/tech7_2.88b9c149.jpg";